/* eslint-disable react/require-default-props */
import React from 'react';

import Card from '/component/base/Card';
import Text from '/component/base/Text';
import {HealthProfileTestIds} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {waistInchesLost, weightChangeImperial} from '../HealthProfile.util';
import WeightTileGraph from '../WeightTileGraph';

import {styles} from './WeightTracker.style';

interface WeightTrackerProps {
  hasUpdates: boolean;
  inchesLost?: any;
  weightGraph: {
    data?: {
      currentWeightLog?: {
        weight?: {
          weightInPounds?: {};
        };
      };
      weightChange?: {
        imperial?: {};
      };
    };
  };
}

export const WeightTracker: React.FC<WeightTrackerProps> = ({
  hasUpdates,
  inchesLost,
  weightGraph,
}) => {
  const {ts} = useTranslation('weighttracking');

  return (
    <Card style={styles.cardContainer}>
      <Text
        isBold
        style={styles.secondaryTitle}
        {...testProperties(HealthProfileTestIds.weightTrackingHeader)}>
        {ts('WeightTrackingTitle', 'Weight tracking')}
      </Text>
      <WeightTileGraph
        weightGraph={weightGraph}
        inchesLost={inchesLost}
        labels={[]}
      />
      {hasUpdates && (weightGraph !== undefined || inchesLost !== undefined) ? (
        <>
          {weightGraph?.data ? (
            weightChangeImperial(weightGraph)
          ) : (
            <Text
              isBold
              style={styles.textLabel}
              {...testProperties(HealthProfileTestIds.weightLossLabel)}>
              {ts('Weight lost', 'Weight lost since starting: -- lbs')}
            </Text>
          )}
          {inchesLost !== undefined ? (
            <Text
              isBold
              style={styles.textLabel}
              {...testProperties(HealthProfileTestIds.waistSizeLostLabel)}>
              {waistInchesLost(inchesLost)}
            </Text>
          ) : (
            <Text
              isBold
              style={styles.textLabel}
              {...testProperties(HealthProfileTestIds.waistSizeLostLabel)}>
              {ts('Inches lost', 'Total Inches lost since starting: -- in')}
            </Text>
          )}
        </>
      ) : (
        <>
          <Text
            isBold
            style={styles.textLabel}
            {...testProperties(HealthProfileTestIds.weightLossLabel)}>
            {ts('Weight lost', 'Weight lost since starting: -- lbs')}
          </Text>
          <Text
            isBold
            style={styles.textLabel}
            {...testProperties(HealthProfileTestIds.waistSizeLostLabel)}>
            {ts('Inches lost', 'Total Inches lost since starting: -- in')}
          </Text>
          <Text
            isBold
            style={styles.noUpdateslabel}
            {...testProperties(HealthProfileTestIds.noUpdatesLabel)}>
            {ts(
              'NoUpdates',
              "Your client hasn't shared full details yet. Remind them to add their health info in app and start tracking progress together!",
            )}
          </Text>
        </>
      )}
    </Card>
  );
};

export default WeightTracker;
